"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mergeAttribute = function (attributes, key) {
    // attributes we need to merge
    var toMerge = [];
    // remove the attributes that match the key
    var result = attributes.filter(function (val) {
        if (val.key === key) {
            toMerge.push(val);
            return false;
        }
        return true;
    });
    // if we have any, merge'em
    if (toMerge.length > 0) {
        var value = toMerge.map(function (val) { return val.value; }).join(', ');
        result.push({ key: key, value: value });
    }
    return result;
};
exports.default = mergeAttribute;
//# sourceMappingURL=merge-attribute.js.map